import ObserverUtil from 'common/util/ObserverUtil';
import MatchMedia from 'common/util/MatchMedia';
import ResponsiveUtil from 'common/util/ResponsiveUtil';
import ComponentRegistry from 'common/util/ComponentRegistry';
import Update from 'common/util/Update';
import OnUpdate from 'common/util/OnUpdate';
import Select from 'common/util/Select';
import ModalUtil from 'common/util/ModalUtil';
import TouchLockUtil from 'common/util/TouchLockUtil';
import ScrollUtil from 'common/util/ScrollUtil';
import ScrollLockUtil from 'common/util/ScrollLockUtil';
import JivoWidget from 'assembly/parts/blocks/jivo-widget/jivo-widget';

window.ObserverUtil = ObserverUtil;
window.MatchMedia = MatchMedia;
window.ResponsiveUtil = ResponsiveUtil;
window.ComponentRegistry = ComponentRegistry;
window.Component = ComponentRegistry.register;
window.Update = Update;
window.OnUpdate = OnUpdate;
window.Select = Select;
window.ModalUtil = ModalUtil;
window.TouchLockUtil = TouchLockUtil;
window.ScrollUtil = ScrollUtil;
window.ScrollLockUtil = ScrollLockUtil;
window.JivoWidget = JivoWidget();
